import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ApiConfiguration} from "../api/api-configuration";
import {backendURL} from "../constants/globalConstants";
import {HttpClient} from "@angular/common/http";
import {BackendDataService} from "../services/backend-data.service";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SimpleModalComponent} from "./common/simple-modal/simple-modal/simple-modal.component";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, FormsModule, ReactiveFormsModule, SimpleModalComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent {

  // constructor(private translate: TranslateService) {
  //   translate.setDefaultLang('en');
  // }

  constructor(private http: HttpClient, private backendData: BackendDataService) {
    const apiConfiguration = inject(ApiConfiguration);
    apiConfiguration.rootUrl = backendURL
  }

  ngOnInit() {
    this.http.get<string[]>(backendURL + "/json/brands.json").subscribe((data: string[]) => {
      this.backendData.brands = data.filter(data => data.length > 0).sort();
    })

    this.http.get<string[]>(backendURL + "/json/regions.json").subscribe((data: string[]) => {
      this.backendData.regions = data.filter(data => data.length > 0).sort()
    })

    this.http.get<string[]>(backendURL + "/json/countries.json").subscribe((data: string[]) => {
      this.backendData.countries = data.filter(data => data.length > 0).sort()
    })

    this.http.get<string[]>(backendURL + "/json/regions_tw.json").subscribe((data: string[]) => {
      this.backendData.regionsTw = data.filter(data => data.length > 0).sort()
    })

    this.backendData.refreshTimestamp();

  }

}
